<template>
    <div class="flex mt-0 mb-px draggable relative" :key="itemKey">
        <!-- Draggable handle. -->
        <div class="w-6 flex-shrink-0 py-1.5 -my-px border-t">
            <div class="w-5 h-5 flex items-center">
                <i class="fa fa-bars fa-fw text-xs text-gray-300 hover:text-gray-400 cursor-move pl-1 handle"
                   v-if="!estimate.readonly"></i>
            </div>
        </div>

        <!-- Description. -->
        <div
            class="flex flex-1 flex-col m-0 -ml-px -mt-px -mb-px border border-gray-200 shadow-none"
            :class="estimate.readonly?'':'hover:border-gray-400 hover:z-10'">
            <template v-if="estimate.readonly">
                <div
                    class="bg-white text-sm m-0 px-2 pt-1.5 pb-1.5 shadow-none relative whitespace-pre-wrap focus:border-blue-500 border-none focus:z-20 resize-none"
                    style="min-height: 34px"
                    v-text="attendance.description">
                </div>
            </template>
            <autoresizable-textarea :height="getHeight"
                                    ref="autoresizable-description"
                                    v-else
            >
                    <textarea
                        placeholder="Description..."
                        class="text-sm m-0 px-2 pt-1.5 pb-1.5 shadow-none relative focus:border-blue-500 border-none focus:z-20 resize-none"
                        type="text"
                        ref="description"
                        :disabled="estimate.readonly"
                        v-model="attendance.description"
                        @input="estimate.update()"
                        @change="estimate.addSnapshot()"
                        rows="1"
                    ></textarea>
            </autoresizable-textarea>
        </div>

        <!-- Others -->
        <div class="w-20 -mt-px -ml-px -mr-px -mb-px border-b border-l border-t">
            <ui-toggle class="pt-1.5 px-3 " field="text-lg text-gray-900"
                       v-model="attendance.others" @input="update" :disabled="estimate.readonly"></ui-toggle>
        </div>

        <!-- Us -->
        <div class="w-20 -mt-px -ml-px -mr-px -mb-px border-b border-l border-t">
            <ui-toggle class="pt-1.5 px-3" field="text-lg text-gray-900"
                       v-model="attendance.us" @input="update" :disabled="estimate.readonly"></ui-toggle>
        </div>

        <!-- Comment. -->
        <div
            class="flex flex-1 flex-col m-0 -ml-px -mt-px -mb-px border border-gray-200 shadow-none"
            :class="estimate.readonly?'':'hover:border-gray-400 hover:z-10'">
            <template v-if="estimate.readonly">
                <div
                    class="bg-white text-sm m-0 px-2 pt-1.5 pb-1.5 shadow-none relative whitespace-pre-wrap focus:border-blue-500 border-none focus:z-20 resize-none"
                    style="min-height: 34px"
                    v-text="attendance.comment">
                </div>
            </template>
            <autoresizable-textarea :height="getHeight"
                                    ref="autoresizable-comment"
                                    v-else
            >
                    <textarea
                        placeholder="Comment..."
                        class="text-sm m-0 px-2 pt-1.5 pb-1.5 shadow-none relative focus:border-blue-500 border-none focus:z-20 resize-none"
                        type="text"
                        ref="comment"
                        :disabled="estimate.readonly"
                        v-model="attendance.comment"
                        @input="estimate.update()"
                        @change="estimate.addSnapshot()"
                        rows="1"
                    ></textarea>
            </autoresizable-textarea>
        </div>

        <!-- Dropdown. -->
        <div class="w-6 flex-shrink-0 self-start pt-2 -my-px border-t pl-1 pr-1">
            <ui-dropdown menu-class="p-3 w-56" v-if="!estimate.readonly" >
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                        <i class="fa fa-ellipsis-h"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <ui-dropdown-item v-if="!estimate.readonly" icon="fas fa-trash" danger
                                      @click="deleteLine();close();">Delete
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>
    </div>
</template>

<script>

import draggable from 'vuedraggable'
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import EstimateTaskBundleItem from "./EstimateTaskBundleItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import PageCell from "../../ui/PageCell.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";

export default {
    components: {
        UiDropdownDivider,
        PageCell, UiDropdown, draggable, EstimateTaskBundleItem, AutoresizableTextarea, UiDropdownItem
    },
    props: {
        estimate: Object,
        attendance: Object,
    },
    data() {
        return {
            itemKey:0,
        }
    },
    watch: {
        item: {},
    },
    methods: {
        update() {
            this.estimate.update()
            this.estimate.addSnapshot()
        },
        getHeight(el) {
            let max = 34;
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                area.setAttribute('style', 'height:auto')
            }
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                max = Math.max(max, area.scrollHeight);
            }
            for (let area of el.closest('.draggable').getElementsByTagName('textarea')) {
                area.setAttribute('style', 'height:' + max + 'px;overflow-y:hidden;')
            }
            if (this.focussed) {
                this.focussed.open();
            }
            return max + 'px';
        },
        deleteLine() {
            this.estimate.attendances = this.estimate.attendances.filter((i) => i !== this.attendance);
            this.update()
        },
    }
}
</script>
